export const createElement = (id: string, tag: string) => {
  let element = document.getElementById(id);
  if (!element) {
    element = document.createElement(tag);
    element.setAttribute('id', id);
  }
  return element;
};

export const createDivElement = (id: string): Element => {
  return createElement(id, 'div');
};

export const prependElement = (target: Element, destinationId: string) => {
  const destination = document.getElementById(destinationId);
  if (destination) {
    if (!destination.contains(target)) {
      destination.prepend(target);
    }
  }
  return target;
};
